
   <div class="snack-bar">
      <mat-icon>{{icon}}</mat-icon>
      <span>{{data.message}}</span>
      <mat-icon (click)="closeSnackBar()" class="close-btn">close</mat-icon>
   </div>